export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7703.01c13234.jpg";